import styled from 'styled-components'

import { TypeStyle, untilMd } from '@syconium/little-miss-figgy'

export const Price = styled.span`
  ${TypeStyle.css.headlineExtraExtraSmall};
  color: ${o => o.theme.color.text.primary.on.background};
  display: inline-block;
`

export const DiscountPrice = styled(Price)`
  ${untilMd} {
    margin: 0 0 0 0;
  }
  color: ${o => o.theme.color.text.critical.on.background};
`

export const CrossedOutPrice = styled.span`
  ${TypeStyle.css.headlineExtraExtraSmall};
  color: ${o => o.theme.color.text.tertiary.on.background};
  display: inline-block;
  text-decoration: line-through;
`
